import $ from 'jquery';

$(document).ready(function () {
    $('[data-toggle="tooltip"]').tooltip();
});
